var lib_core = require("lib-core");

var FootprintTerminalInstance = function () {
    lib_core.AbstractInstance.call(this);

    this.pos = this.shadow("pos",
        function(){
            return this.description().pos();
        },
        null,
        [this.description]
    );

    this.angle = this.shadow("angle",
        function(){
            return this.description().angle();
        },
        null,
        [this.description]
    );
};
lib_core.inherit(FootprintTerminalInstance, lib_core.AbstractInstance);
lib_core.JsonParser.registerClass(FootprintTerminalInstance, "FootprintTerminalInstance");

module.exports = FootprintTerminalInstance;

